<template>
  <div :class="`${prefixClass}__wrap`">
    <t-select
      v-if="data && data.length"
      v-model="tmpItem.value"
      :disabled="disabled"
      :filterable="filterable"
      :size="size"
      :clearable="clearable"
      :class="`${prefixClass}__caspanel`"
      @on-select-selected-with-index="$_onSelectSelectedWithIndex">
      <t-option
        v-for="(item, index) in data"
        :value="item.value"
        :key="item.value + index"
        :disabled="item.disabled">
        {{ item.label }}
      </t-option>
    </t-select>
    <span v-show="tmpItem.loading" :class="`${prefixClass}--loading`"><i :class="`${$constants.PREFIX_ICON_CLASS}ani-loop ${$constants.CLASS_MAIN} ${$constants.PREFIX_CLASS}loading icon-gradient-primary`"></i>{{ loading }}</span>
    <t-caspanel
      v-show="!tmpItem.loading"
      v-if="sublist && sublist.length"
      :prefix-class="prefixClass"
      :data="sublist"
      :disabled="disabled"
      :size="size"
      :clearable="clearable"
      :filterable="filterable"
      :change-on-select="changeOnSelect"></t-caspanel>
    <div class="clearfix"></div>
  </div>
</template>
<script>
import TSelect from '../select/select.vue'
import Emitter from '../../mixins/emitter'
import { findComponentUpward } from '../../utils/assist'
import locale from '../../mixins/locale'
import { t } from '../../locale'

export default {
  name: 'TCaspanel',
  components: { TSelect },
  mixins: [locale, Emitter],
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    size: String,
    clearable: Boolean,
    disabled: Boolean,
    changeOnSelect: Boolean,
    prefixClass: String,
    filterable: Boolean
  },
  data() {
    return {
      loading: t('t.cascader.loading'),
      tmpItem: {},
      result: [],
      sublist: [],
      tmpSelectedItem: '' // 用于存储上一次选中的value
    }
  },
  watch: {
    data() {
      this.sublist = []
    }
  },
  mounted() {
    this.$on('on-find-selected', params => {
      const val = params.value
      let value = [...val]
      for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < this.data.length; j++) {
          if (value[i] === this.data[j].value) {
            this.$_setInitVal(this.data[j], true)
            value.splice(0, 1)
            this.$nextTick(() => {
              this.broadcast('TCaspanel', 'on-find-selected', {
                value: value
              })
            })
            return false
          }
        }
      }
    })
    this.$on('on-clear', () => {
      this.sublist = []
      this.tmpItem = {}
    })
  },
  methods: {
    $_setInitVal(item, fromInit = false) {
      if (item.disabled) return
      const backItem = this.$_getBaseItem(item)
      this.tmpItem = backItem
      if (item.loading !== undefined && !item.children.length) {
        const cascader = findComponentUpward(this, 'TCascader')
        if (cascader && cascader.loadData) {
          this.tmpItem.loading = true
          cascader.loadData(item, () => {
            this.tmpItem.loading = false
            this.$_handleTriggerItem(item)
          })
          return
        }
      }

      // 向上递归，设置临时选中值（并非真实选中）
      this.$_emitUpdate([backItem])
      if (item.children && item.children.length) {
        this.sublist = item.children
        this.dispatch('TCascader', 'on-result-change', {
          lastValue: false,
          changeOnSelect: this.changeOnSelect,
          fromInit: fromInit
        })
      } else {
        this.sublist = []
        this.dispatch('TCascader', 'on-result-change', {
          lastValue: true,
          changeOnSelect: this.changeOnSelect,
          fromInit: fromInit
        })
      }
    },
    $_onSelectSelectedWithIndex(index) {
      this.$_handleTriggerItem(this.data[index])
    },
    $_handleTriggerItem(item, fromInit = false) {
      if (item.disabled) return
      const backItem = this.$_getBaseItem(item)
      this.tmpItem = backItem
      if (item.loading !== undefined && !item.children.length) {
        const cascader = findComponentUpward(this, 'TCascader')
        if (cascader && cascader.loadData) {
          this.tmpItem.loading = true
          cascader.loadData(item, () => {
            this.tmpItem.loading = false
            this.$_handleTriggerItem(item)
          })
          return
        }
      }

      // 向上递归，设置临时选中值（并非真实选中）
      this.$_emitUpdate([backItem])
      if (item.children && item.children.length) {
        this.sublist = item.children
        // 如果现在选择的值和上一次选择的值一样， 此时不需要更新值
        if (this.changeOnSelect) {
          if (this.tmpItem.value !== this.tmpSelectedItem) {
            this.dispatch('TCascader', 'on-result-change', {
              lastValue: false,
              changeOnSelect: this.changeOnSelect,
              fromInit: fromInit
            })
          }
        } else {
          this.dispatch('TCascader', 'on-result-change', {
            lastValue: false,
            changeOnSelect: this.changeOnSelect,
            fromInit: fromInit
          })
        }
      } else {
        this.sublist = []
        // 如果现在选择的值和上一次选择的值一样， 此时不需要更新值
        if (this.changeOnSelect) {
          if (this.tmpItem.value !== this.tmpSelectedItem) {
            this.dispatch('TCascader', 'on-result-change', {
              lastValue: true,
              changeOnSelect: this.changeOnSelect,
              fromInit: fromInit
            })
          }
        } else {
          this.dispatch('TCascader', 'on-result-change', {
            lastValue: true,
            changeOnSelect: this.changeOnSelect,
            fromInit: fromInit
          })
        }
      }
      // 设置上次选中的值
      this.tmpSelectedItem = this.tmpItem.value
    },
    updateResult(item) {
      this.result = [this.tmpItem].concat(item)
      this.$_emitUpdate(this.result)
    },
    $_getBaseItem(item) {
      let backItem = Object.assign({}, item)
      if (backItem.children) {
        delete backItem.children
      }

      return backItem
    },
    $_emitUpdate(result) {
      this.$parent && this.$parent.updateResult(result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// caspanel.vue?d63d10e6